import { AxiosRequestConfig } from 'axios';

import { ConfirmarTokenPosPago, LinkPagamento } from 'src/models/LinkPagamento';

import { APIResponse } from '../models/ApiResponse.model';
import { AdyenPaymentStatus, ThreeDSecureDetails } from '../models/Pagamento.model';
import { adyenPaymentSession } from '../shared/store/Pagamento/adyenPayment.slice';
import { yunoPaymentSession } from '../shared/store/Pagamento/yunoPayment.slice';
import { AppDispatch } from '../shared/store/store';

import Service from './Service';

class LinkPagamentoService extends Service {
  static initiateCheckout(type: string) {
    return async (dispatch: AppDispatch) => {
      const response = await this.Http.get<string>(`/linkpagamento/sessaoadyen/${type}`).then(
        this.getData
      );

      dispatch(adyenPaymentSession(response));
    };
  }

  static initiateCheckoutYuno(idSolicitacaoLink: string) {
    return async (dispatch: AppDispatch) => {
      const response = await this.Http.get<
        | string
        | {
            checkoutSession: string;
            merchantOrderId: string;
          }
      >(`/linkpagamento/sessaoyuno/${idSolicitacaoLink}`).then(this.getData);

      dispatch(yunoPaymentSession(response));
    };
  }

  static async createPaymentYuno(
    idSolicitacaoLink: string,
    payload: {
      oneTimeToken: string;
      checkoutSession: string;
      merchantOrderId: string;
    }
  ): Promise<any> {
    return this.Http.post<any>(
      `/linkpagamento/sessaoyuno/${idSolicitacaoLink}/payments`,
      payload
    ).then(this.getData);
  }

  static getPaymentDetails(threeDSecureDetails: ThreeDSecureDetails, config?: AxiosRequestConfig) {
    return this.Http.post<AdyenPaymentStatus>(
      `/linkpagamento/sessaoadyen/detail`,
      threeDSecureDetails,
      config
    ).then(this.getData);
  }

  static async buscar(id: string) {
    return this.Http.get<APIResponse<LinkPagamento>>(`/linkpagamento/consultar/${id}`)
      .then(this.getData)
      .then((resp) => resp.data);
  }

  static async confirmarTokenPosPago(data: ConfirmarTokenPosPago) {
    return this.Http.post(`/linkpagamento/autorizar`, data)
      .then(this.getData)
      .then((resp) => resp.data);
  }
}

export default LinkPagamentoService;
